const topbar = {
    docs: '문서',
    help: '도움말',
    subscription: '구독',
};
export default Object.freeze(topbar);
